import React, { PropsWithChildren, ReactElement } from "react";

interface Props {}

export function AppBoxActionCards(props: PropsWithChildren<Props>): ReactElement {
  return <div className="AppBoxActionCards">{props.children}</div>;
}
